import { get, post } from './axios'
import router from '@/router/index.js'

// get
// export const get_form = data => get('replies/form', data)
// export const lastPage = data => get('replies/prev', data)

// post
export const amazon_order_id = data => post('form_items/amazon_order_id', data) // 验证亚马逊订单号是否有效

export const getvxuserinfo = data => post('gzh/getvxuserinfo', data) // 获取用户的openid
export const postordergift = data => post('gzh/postordergift', data) // 领取奖品
export const ordergiftdetail = data => post('gzh/ordergiftdetail', data) // 获取晒单详情

export const postwarrantycard = data => post('gzh/postwarrantycard', data) // 保修卡提交
export const warrantycarddetail = data => post('gzh/warrantycarddetail', data) // 获取保修卡详情
export const inusewarrantycards = data => post('gzh/inusewarrantycards', data) // 在用保修卡
export const invalidwarrantycards = data => post('gzh/invalidwarrantycards', data) // 失效保修卡

export const screenshotUrl = process.env.VUE_APP_API_URL + 'gzh/upload' // 上传截图相关数据地址
export const uploadPicture = data => post('gzh/upload', data) // 上传图片
